import { styled, keyframes } from "styled-components";

import { redundantCssFromKebab } from "../../styles/redundant-css";

export function generateFadeOutKeyframes(
    displayDuration: number,
    transitionDuration: number
): ReturnType<typeof keyframes> {
    const totalTime = displayDuration + transitionDuration;
    const transitionEventRawValue = (displayDuration / totalTime) * 100;
    const transitionEventPercent = `${transitionEventRawValue.toFixed(6)}%`;

    return keyframes`
        0% {
            opacity: 1;
        }
        ${transitionEventPercent} {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    `;
}

export const Container = styled.div`
    ${redundantCssFromKebab("display", "grid")}
    ${redundantCssFromKebab("grid-template-columns", "100%")}
`;

export type RotatingItemProps = {
    readonly hasAnimation: boolean;
    readonly displayDuration: number;
    readonly transistionDuration: number;
};

export const RotatingItem = styled.div<RotatingItemProps>`
    animation-name: ${({
        hasAnimation,
        displayDuration,
        transistionDuration
    }) =>
        hasAnimation
            ? generateFadeOutKeyframes(displayDuration, transistionDuration)
            : "none"};
    animation-duration: ${({
        hasAnimation,
        displayDuration,
        transistionDuration
    }) =>
        hasAnimation ? `${displayDuration + transistionDuration}ms` : "0ms"};
    animation-timing-function: ease-out;
    opacity: ${({ hasAnimation }) => (hasAnimation ? 0 : 1)};
    display: flex;
    grid-row: 1;
    grid-column: 1;
    height: 100%;
    position: relative;

    > .ui-section {
        height: 100%;
        width: 100%;
        display: flex;

        .ui-section__container,
        .ui-section__row {
            width: 100%;
            height: 100%;
            display: flex;
        }
    }
`;
